<template>
  <div class="father">
    <div class="top-condition">
      <div class="top-condition-line">
        <el-form
          ref="form"
          :inline="true"
          :model="conditions"
          label-width="85px"
        >
          <el-form-item label="店铺筛选：">
            <el-select
              size="mini"
              :multiple-limit="2"
              v-model="conditions.mch_list"
              @change="mchSelectChange"
              style="width: 300px"
              multiple
              placeholder="选择店铺"
            >
              <el-option-group
                v-for="group in mch_list"
                :key="group.label"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-option-group>
            </el-select>
          </el-form-item>
          <el-form-item label="销量排行：">
            <el-radio-group size="mini" v-model="conditions.sale_top">
              <el-radio-button label="10">前10</el-radio-button>
              <el-radio-button label="50">前50</el-radio-button>
              <el-radio-button label="100">前100</el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="日期筛选：">
            <el-date-picker
              size="mini"
              v-model="conditions.date"
              @change="salesDateChange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item >
            <el-button size="mini" type="primary" style="width: 100px;"> 刷新</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="top-condition-line"></div>
      <div class="top-condition-line">
        <dyh-goods-search
          ref="dyhgoodssearchRef"
          @getGoods="getGoods"
          @dyhGoodsSearchReturn="dyhGoodsSearchReturn"
          :who="'goodsSales'"
        ></dyh-goods-search>
      </div>
    </div>
    <div class="bottom-table">
      <el-empty
        v-if="all_mch_list.length == 0"
        description="当前未选中店铺，请先选择店铺"
      ></el-empty>
      <div class="bottom-table-flex" v-else>
        <div
          style="width: 48%; margin-right: 2%"
          v-for="(item, index) in all_mch_list"
          :key="index"
        >
        <div class="title" > {{item.mch_name}}</div>
          <ve-table
            style="width: 100%"
            border-x
            border-y
            ref="goodstableRef"
            :columns="list_columns"
            :fixed-header="true"
            :maxHeight="`${tbmax_height}px`"
            rowKeyFieldName="rowKey"
            :table-data="item.show_salse_list"
            :sort-option="sortOption"
            :rowStyleOption="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :event-custom-option="eventCustomOption"
            :virtual-scroll-option="virtualScrollOption"
            enable="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dyhGoodsSearch from "@/components/dyh-goodsSearch.vue";
import { salesInfoColumn, cellStyleOption } from "@/js/sheettablecolumn.js";

export default {
  components: {
    dyhGoodsSearch
  },
  mounted() {
    this.list_columns = salesInfoColumn;
  },
  data() {
    return {
      allGoods_list: "", //所有商品列表
      all_mch_list: [
        //选中的所有店铺
      ],
      conditions: {
        sale_top: 10,
        mch_list: [], //选中的店铺
        date: "" //日期
      }, //所有条件

      mch_list: [
        {
          label: "河北保定",
          options: [
            {
              label: "保定正源电气保定",
              value: "4973645190"
            }
          ]
        },
        {
          label: "江苏淮安",
          options: [
            {
              label: "江苏峰厦网络科技",
              value: "4764174126"
            },
            {
              label: "江苏多易禾",
              value: "5431235550"
            }
          ]
        },
        {
          label: "陕西西安",
          options: [
            {
              label: "西安太康生物",
              value: "4765298903"
            }
          ]
        }
      ], //可以查看的店铺
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      list_columns: [], //列表的表头
      tbmax_height: 460, //列表最大高度
      // 是否开启虚拟滚动
      virtualScrollOption: {
        // 是否开启
        enable: true
      },
      //单元格样式
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
        ...cellStyleOption
      },
      // 表格自定义的单机事件
      eventCustomOption: {
        bodyCellEvents: ({ row, column, rowIndex }) => {
          return {
            click: (event) => {
              // console.log("click::", row, column, rowIndex, event);
            }
          };
        }
      },
      rowStyleOption: {
        clickHighlight: false,
        stripe: true
      },
      // 排序
      sortOption: {
        sortChange: (params) => {
          // console.log("sortChange::", params);
          this.sortChange(params);
        }
      }
    };
  },

  methods: {
    /**
     * 店铺选择修改
     * @param e
     */
    mchSelectChange(e) {
      this.all_mch_list = [];
      //选中的所有店铺
      for (let i = 0; i < e.length; i++) {
        const data = {
          //搜索该店铺的销量top
          mch_no: e[i], //店铺号
          mch_name: this.getMchName(e[i]),
          all_sales_list: [], //所有商品
          show_salse_list: [] //需要显示的商品
        };
        this.all_mch_list.push(data);
      }
    },
    /**
     * 返回店名
     * @param {string} mch_no 店铺id
     */
    getMchName(mch_no) {
      console.log("mch_no", mch_no);
      for (let i = 0; i < this.mch_list.length; i++) {
        const option = this.mch_list[i].options;
        console.log("option", option);
        for (let j = 0; j < option.length; j++) {
          const item = option[j];
          console.log("list", item);

          if (item.value === mch_no) return item.label;
        }
      }
    },
    /**
     * 日期选择组件修改
     * @param e
     */
    salesDateChange(e) {
      console.log("e 销售时间改变", e);
    },
    /**
     *点击搜索按钮搜索商品
     */
    getGoods() {
      this.$refs.dyhgoodssearchRef.search(this.allGoods_list);
    },
    /**
     * dyh-goods-search 组件返回
     * @param {{keys:string,list:object[]}} obj obj-keys 传入的标识位 obj-list 返回的符合条件的列表
     */
    dyhGoodsSearchReturn(obj) {}
  }
};
</script>
<style lang="less" scoped>
.title{
  font-size: 18px;
  font-weight:700;
  color: #303133;
}
.father {
  width: 100%;
  height: 100%;
  padding: 5px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 5px;
}
.top-condition {
  width: 100%;
  height: 120px;
  .top-condition-line {
    width: 100%;
    height: 40px;
    padding: 2px;
    display: flex;
    flex-wrap: wrap;
  }
}
.bottom-table {
  width: 100%;
  height: auto;
  min-height: 400px;
}
.bottom-table-flex {
  display: flex;
  justify-content: left;
}
.el-form-item {
  margin-bottom: 0;
}
</style>